import { configureStore } from "@reduxjs/toolkit";
import loadingReducer from "./loadingSlice";
import checkLoginReducer from "./checkLoginSlice";
import toggleSidebar from "./toggleSlice";
import appDataSlice from "./appDataSlice";

export default configureStore({
    reducer: {
        loading: loadingReducer,
        login: checkLoginReducer,
        toggle: toggleSidebar,
        appData: appDataSlice
    },
});